"use client"

import { useHypertune } from "lib/feature-flags/generated/hypertune.react"
import React from "react"

import {
    Icon,
    IconButton,
    Popover,
    PopoverContent,
    PopoverTrigger,
    Portal,
    PortalManager,
    VStack
} from "@chakra-ui/react"
import { ViewGridIcon } from "@heroicons/react/solid"

import NavCategoryHeader from "./components/NavCategoryHeader"
import { BaseNavigationLinks, OrgNavigationLinks, RootNavigationLinks } from "./links"

const OrganizationPopover: React.FC<{ isDisabled: boolean }> = ({ isDisabled }) => {
    const [isOpen, setIsOpen] = React.useState(false)

    const hypertune = useHypertune()

    const displayOrgs =
        hypertune.userIsSuperadmin({ fallback: false }) ||
        Object.values(hypertune.activeFeatures().orgs).some((flag) => !!flag)

    return (
        <Popover
            isOpen={isOpen}
            onOpen={() => setIsOpen(true)}
            onClose={() => setIsOpen(false)}
            placement='bottom-end'
            closeOnBlur={true}
            closeOnEsc={true}
            isLazy={true}
        >
            <PopoverTrigger>
                <IconButton
                    aria-label='Organization popover'
                    icon={<Icon as={ViewGridIcon} boxSize={5} />}
                    variant='nude'
                    rounded='xl'
                    isDisabled={isDisabled}
                    fontSize='2xl'
                    bg='gray.50'
                    h={9}
                    w={9}
                    color='gray.400'
                    _dark={{
                        bg: "gray.500",
                        color: "gray.300"
                    }}
                    _hover={{
                        bg: "green.100",
                        color: "green.500",
                        _dark: {
                            bg: "gray.600",
                            color: "gray.200"
                        }
                    }}
                />
            </PopoverTrigger>
            <PortalManager zIndex={40}>
                <Portal>
                    <PopoverContent className='w-72 rounded-lg rounded-t-none border-0 bg-white p-6 shadow-lg dark:bg-gray-800'>
                        <VStack
                            onClick={({ target }) => target && setIsOpen(false)}
                            gap={6}
                            alignItems='start'
                            w='full'
                        >
                            <BaseNavigationLinks />
                            <div className='flex w-full flex-col items-start gap-2'>
                                <NavCategoryHeader title='Apps' />
                                <RootNavigationLinks />
                            </div>
                            {displayOrgs && (
                                <div className='flex w-full flex-col items-start gap-2'>
                                    <NavCategoryHeader title='Organization' />
                                    <OrgNavigationLinks />
                                </div>
                            )}
                        </VStack>
                    </PopoverContent>
                </Portal>
            </PortalManager>
        </Popover>
    )
}

export default OrganizationPopover
